import React, { useContext, useState } from 'react'
import { connectMenu } from 'react-instantsearch-dom'
import Select from 'react-select'
import { ThemeContext } from 'styled-components'
import { debounce } from 'lodash'

const LocationDropdown = ({ refine, items, searchForItems }) =>  {
  const [open, setOpen] = useState(false)
  const themeContext = useContext(ThemeContext)
  const value = items.find(item => item.isRefined)
  const onInputChange = debounce(str => {
    searchForItems(str)
    setOpen(str ? true : false)
  }, 250)
  return <Select
    options={items}
    value={value}
    menuIsOpen={open}
    blurInputOnSelect={true}
    isClearable={true}
    placeholder='Search by Location...'
    onInputChange={onInputChange}
    onChange={option => (option && option.isRefined) || refine(option ? option.value : '')}
    isOptionSelected={option => option.isRefined}
    styles={{
      indicatorSeparator: provided => ({
        ...provided,
        display: 'none',
      }),
      dropdownIndicator: provided => ({
        ...provided,
        display: 'none',
      }),
      control: provided => ({
        ...provided,
        borderColor: '#757575',
        minHeight: '',
      }),
      menu: provided => ({
        ...provided,
        margin: 0,
        zIndex: 2,
      }),
      menuList: provided => ({
        ...provided,
        padding: 0,
      }),
      singleValue: provided => ({
        ...provided,
        color: '#757575',
      }),
      option: provided => ({
        ...provided,
        lineHeight: '21px',
      }),
      placeholder: provided => ({
        ...provided,
        margin: 0,
      }),
      valueContainer: provided => ({
        ...provided,
        padding: '4px 12px',
      }),
      input: provided => ({
        ...provided,
        margin: 0,
        padding: 0,
      }),
    }}
    theme={theme => ({
      ...theme,
      borderRadius: 0,
      fontSize: 20,
      colors: {
        ...theme.colors,
        primary: themeContext.colors.primary,
        primary25: '#E0E0E0',
      },
    })}
  />
}

export default connectMenu(LocationDropdown)
